import React from 'react'
import { Link } from 'react-router-dom'

const icons = {
  education: 'M12 2L2 7l10 5 10-5-10-5z M2 17l10 5 10-5 M2 12l10 5 10-5',
  health: 'M22 12h-4l-3 9L9 3l-3 9H2',
  'self-reliance': 'M12 20h9 M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z',
  'social-harmony': 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2 M9 11a4 4 0 100-8 4 4 0 000 8z M23 21v-2a4 4 0 00-3-3.87 M16 3.13a4 4 0 010 7.75',
  'sewa-shri-ashram': 'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z M9 22V12h6v10',
  'govind-nilayam-hostel': 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z M4 22v-7',
  'sewa-dham': 'M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z',
  'sewa-darshan': 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z M12 12m-3 0a3 3 0 106 0 3 3 0 00-6 0',
}

function getIcon(slug) {
  const key = Object.keys(icons).find(k => slug.includes(k)) || 'education'
  return icons[key]
}

export default function Card({ title, slug, description, index = 0 }) {
  return (
    <Link to={`/service/${slug}`} className="block group h-full">
      <div className="bg-white rounded-2xl p-7 h-full flex flex-col relative overflow-hidden transition-all duration-300 group-hover:-translate-y-2"
        style={{border:'1px solid rgba(0,0,0,0.07)', boxShadow:'0 2px 12px rgba(13,27,62,0.05)'}}>

        {/* Top accent bar on hover */}
        <div className="absolute top-0 left-0 right-0 h-[3px] rounded-t-2xl origin-left transition-transform duration-300 scale-x-0 group-hover:scale-x-100"
          style={{background:'linear-gradient(90deg,var(--saffron),var(--saffron-light))'}}/>

        {/* Number */}
        <div className="font-bold leading-none mb-4 transition-colors duration-300" style={{fontFamily:'Playfair Display,serif',fontSize:'48px',color:'rgba(232,103,10,0.08)'}}>
          {String(index + 1).padStart(2, '0')}
        </div>

        {/* Icon */}
        <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 transition-all duration-300 flex-shrink-0"
          style={{background:'var(--saffron-pale)'}}>
          <svg className="w-6 h-6 transition-colors duration-300" fill="none" stroke="var(--saffron)" strokeWidth="1.8" viewBox="0 0 24 24"
            style={{color:'var(--saffron)'}}>
            <path d={getIcon(slug)}/>
          </svg>
        </div>

        <h3 className="font-semibold text-base mb-2.5 leading-snug" style={{color:'var(--navy)'}}>{title}</h3>
        <p className="text-sm leading-relaxed flex-1" style={{color:'var(--muted)',display:'-webkit-box',WebkitLineClamp:3,WebkitBoxOrient:'vertical',overflow:'hidden'}}>{description}</p>

        <div className="mt-5 flex items-center gap-2 text-sm font-medium transition-colors duration-200" style={{color:'var(--muted)'}}>
          <div className="w-7 h-7 rounded-full flex items-center justify-center transition-all duration-300" style={{background:'rgba(0,0,0,0.05)'}}>
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
          </div>
          Read more
        </div>
      </div>
    </Link>
  )
}
